var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ViewPDF",on:{"contextmenu":_vm.disableRightClick}},_vm._l((_vm.numPages),function(i){return _c('pdf',{key:i,staticStyle:{"display":"inline-block","width":"100%"},attrs:{"src":_vm.src,"page":i}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }